<template>
	<div data-tour-scope="setting-unit">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.subsetting.unit') }} </v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>

							<v-spacer></v-spacer>
							<v-btn depressed color="primary" data-tour="add" @click="createItem"><v-icon left>mdi-plus</v-icon>Nuova unità</v-btn>
						</v-toolbar>

						<!-- telefono: ogni unita' di misura diventa una card chiave/valore -->
						<div v-if="mobileCards" class="kv-list unit-cards pa-3" data-tour="table">
							<div v-if="!units.length" class="grey--text text-center py-4">Nessun elemento</div>
							<key-value-card v-for="(item, index) of units" :key="item._id" :title="nomeUnita(item) || 'Unità di misura'">
								<template v-slot:actions>
									<v-chip v-if="item.default" x-small outlined color="primary" class="mr-1">Predefinita</v-chip>
									<v-btn small icon color="primary" :data-tour="index === 0 ? 'expand' : null" :title="checkpresenza(index) ? 'Chiudi' : 'Traduzioni'" @click="extension(index)">
										<v-icon>{{ checkpresenza(index) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
									</v-btn>
									<v-menu v-if="!item.default" left eager>
										<template v-slot:activator="{ on, attrs }">
											<v-btn icon small color="primary" v-bind="attrs" v-on="on" :data-tour="index === primaNonDefault ? 'row-menu' : null">
												<v-icon>mdi-dots-vertical</v-icon>
											</v-btn>
										</template>
										<v-list>
											<v-list-item link @click="changeDefault(index)">
												<v-list-item-title class="size9">Rendi predefinita</v-list-item-title>
											</v-list-item>
											<v-list-item link @click="deleteItem(item)">
												<v-list-item-title class="size9 error--text">Elimina</v-list-item-title>
											</v-list-item>
										</v-list>
									</v-menu>
								</template>
								<div class="d-flex align-center justify-space-between">
									<span class="card-label">Status</span>
									<v-switch :data-tour="index === 0 ? 'switch' : null" v-model="item.is_active" @change="changeStatus(index)" color="primary" class="mt-0 pt-0" hide-details></v-switch>
								</div>
								<div v-if="checkpresenza(index)" class="up-detail mt-3" :data-tour="index === 0 ? 'settings' : null">
									<div class="up-body">
										<div class="up-section">Nome per lingua</div>
										<TestiLinguaTabs :trans="item.trans" campo="unit" label="Unità" :traduci="languages.length > 1" @traduci="traduci(item)" />
									</div>
									<div class="up-foot">
										<v-btn depressed small color="primary" @click="save">Salva</v-btn>
									</div>
								</div>
							</key-value-card>
						</div>
						<v-simple-table v-else data-tour="table">
							<template v-slot:default>
								<thead>
									<tr>
										<th style="width: 40px"></th>
										<th style="width: 40px"></th>
										<th class="text-left">Unità di misura</th>
										<th class="text-left">Status</th>
										<th class="text-left">Default</th>
									</tr>
								</thead>
								<tbody>
									<tr v-if="!units.length">
										<td colspan="5" class="grey--text text-center">Nessuna unità: aggiungila con "Nuova unità"</td>
									</tr>
									<template v-for="(item, index) of units">
										<tr :key="item._id" class="as-list-row" :class="{ 'as-list-row--open': checkpresenza(index) }" @click="extension(index)">
											<td class="pl-0 pr-0" style="width: 40px" @click.stop>
												<v-menu v-if="!item.default" right eager>
													<template v-slot:activator="{ on, attrs }">
														<v-btn icon small color="primary" v-bind="attrs" v-on="on" :data-tour="index === primaNonDefault ? 'row-menu' : null">
															<v-icon>mdi-dots-vertical</v-icon>
														</v-btn>
													</template>
													<v-list>
														<v-list-item link @click="changeDefault(index)">
															<v-list-item-title class="size9">Rendi predefinita</v-list-item-title>
														</v-list-item>
														<v-list-item link @click="deleteItem(item)">
															<v-list-item-title class="size9 error--text">Elimina</v-list-item-title>
														</v-list-item>
													</v-list>
												</v-menu>
											</td>
											<td class="pr-0" style="width: 40px">
												<v-btn small icon :data-tour="index === 0 ? 'expand' : null" :title="checkpresenza(index) ? 'Chiudi' : 'Traduzioni'" @click.stop="extension(index)">
													<v-icon>{{ checkpresenza(index) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
												</v-btn>
											</td>
											<td class="font-weight-medium">{{ nomeUnita(item) }}</td>
											<td @click.stop>
												<v-switch :data-tour="index === 0 ? 'switch' : null" v-model="item.is_active" @change="changeStatus(index)" color="primary" class="mt-0" hide-details></v-switch>
											</td>
											<td>
												<v-chip v-if="item.default" small outlined color="primary">Predefinita</v-chip>
											</td>
										</tr>
										<tr v-if="checkpresenza(index)" :key="item._id + '-panel'" class="as-expanded">
											<td colspan="5" class="py-3">
												<div class="up-detail" :data-tour="index === 0 ? 'settings' : null">
													<div class="up-head">
														<v-icon small class="mr-1" color="primary">mdi-translate</v-icon>
														<span class="up-head-title">Traduzioni di «{{ nomeUnita(item) }}»</span>
														<span class="up-muted ml-2">{{ item.is_active ? 'attiva' : 'disattivata' }}</span>
													</div>
													<div class="up-body">
														<div class="up-section">Nome per lingua</div>
														<TestiLinguaTabs :trans="item.trans" campo="unit" label="Unità" :traduci="languages.length > 1" @traduci="traduci(item)" />
														<div class="up-muted up-small mt-2">Scrivi l'unità come la userebbe un cliente (kg, non chilogrammi): finisce accanto ai numeri in spazi stretti.</div>
													</div>
													<div class="up-foot">
														<v-btn depressed small color="primary" @click="save">Salva</v-btn>
													</div>
												</div>
											</td>
										</tr>
									</template>
								</tbody>
							</template>
						</v-simple-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Chiudi </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>
		<TourOverlay :tour="tour"></TourOverlay>

		<v-dialog :eager="true" :retain-focus="false" :value="getDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
			<FormCreate v-if="operation == 'FormCreate'" :key="componentKey" @message="propSetMessages"></FormCreate>
		</v-dialog>
		<v-dialog v-model="dialogconfirm" max-width="380">
			<v-card>
				<v-card-title class="headline">Eliminare l'unità «{{ daEliminare ? nomeUnita(daEliminare) : '' }}»?</v-card-title>
				<v-card-text>Non sarà più possibile ripristinarla.</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="error" text @click="confirmDelete"> Elimina </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import TestiLinguaTabs from './components/TestiLinguaTabs.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createUnitTourSteps, stopUnitTour } from './unit-tour';

import VueLodash from 'vue-lodash';
import lodash from 'lodash';

const FormCreate = () => import('@/components/unit/Create.vue');

export default {
	name: 'Unit',
	setup() {
		return { tour: useTour(createUnitTourSteps(), { onStop: stopUnitTour }) };
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},
	data() {
		return {
			items: [],
			setinterval: '',

			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca
			settings: {
				search: '',
				filters: {
					status: [],
					platform: [],
					created_at: [],
					payments: [],
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			},

			listSize: [15, 25, 50, 100],
			linkdownload: '',
			searchfield: '',
			selected: [],
			// unita' in attesa di conferma nel dialog di eliminazione
			daEliminare: null,

			total: 0,
			expanded: [],
			singleExpand: false,
			headers: [
				{ text: 'Lingua', value: '' },
				{ text: 'Status', value: '' },
				{ text: 'Default', value: '' },
			],

			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,

			dialogconfirm: false,

			isActive: true,

			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},
			form: {
				vat: '',
				is_active: false,
			},

			isMobile: false,
			operation: '',
			componentKey: 0,
			vats: [],
			units: [],
			profile: {},
			lang: '',
			languages: [],
		};
	},
	/*created () {
            this.setDialog(false)
            this.initialize();

        },*/
	components: {
		TourOverlay,
		FormCreate,
		KeyValueCard,
		TestiLinguaTabs,
	},
	filters: {
		fixed: function (value) {
			if (!+value) return '';
			//  return  value = value.toFixed(2)
			return _.round(value, 2);
			//return  value
		},
	},
	/* sockets: {
             connect() {
                 console.log('socket connected')
             },
             customEmit(val) {
                 console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
             }
         },*/

	async mounted() {
		this.setPreload(true);
		/*let languages = this.fetchLanguages()
            languages.then(result => {
                console.log(result)
            })*/
		this.selected = [];
		await this.fetchSettings();

		//console.log(result)

		//this.profile = result

		this.lang = _.find(this.getSettings.languages, { default: true }).lang;
		//this.units = result.unit
		this.getSettings.languages = _.orderBy(this.getSettings.languages, ['default'], ['desc']);
		this.languages = _.filter(this.getSettings.languages, { is_active: true });

		_.forEach(this.getSettings.unit, unit => {
			let arrayNew = [];
			//console.log(unit.trans)
			_.forEach(this.languages, lang => {
				let check = _.find(unit.trans, { lang: lang.lang });
				//console.log(check)
				if (!check) {
					arrayNew.push({ lang: lang.lang, unit: '', _id: '' });
				} else {
					arrayNew.push({ lang: check.lang, unit: check.unit, _id: check._id });
				}
			});
			//console.log(arrayNew)
			unit.trans = arrayNew;
			this.units.push(unit);
			//this.profile.languages = _.orderBy(this.profile.languages,['default'],['desc'])
		});
		//console.log(this.units)
		//this.units = result.unit

		//this.items = result.data.data
		this.setPreload(false);
		//console.log(this.languages)

		//this.selectedall = []
	},

	watch: {
		settings: {},
	},

	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		// riga a cui il tutorial aggancia il menu a tre puntini (la predefinita non ce l'ha)
		primaNonDefault() {
			return this.units.findIndex(u => !u.default);
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getId: 'profile/getId',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getSettings: 'settings/getSetting',
			getDrawerFilter: 'settings/getDrawerFilter',
		}),
		/*Totale(){
                console.log(filteredItems)
                /!*if(filteredItems.length>0) {
                    return filteredItems.reduce((total, current) => {
                        return total + parseFloat(current.Total)
                    })

                }*!/
            },*/
		navStateFilter: {
			get: function (old, newvalue) {
				return this.getDrawerFilter;
			},
			set: function (newvalue) {
				return this.getDrawerFilter;
			},
		},
	},

	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',
			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchSettings: 'settings/asyncFetchData',
			fetchLanguages: 'languages/asyncFetchData',
			destroyData: 'settings/destroyData',
			setSettings: 'settings/updateData',

			//'resetMessages' : 'settings/resetMessages'
		}),
		propSetMessages(text) {
			this.units = this.getSettings.unit;
			this.snackbar.color = 'success';
			this.snackbar.text = text;
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
			this.operation = '';
		},
		copia(item) {
			var master = item.trans[0].unit;
			_.forEach(item.trans, trans => {
				trans.unit = master;
			});
		},
		async createItem() {
			this.componentKey += 1;
			this.setClearError({});
			//await this.resetMessages();
			//console.log(this.getOrders.indexOf(item));
			//console.log(item)
			this.operation = 'FormCreate';

			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
			/*Vue.component(
                    'FormEdit',
                    // A dynamic import returns a Promise.
                    () => import('@/components/orders/Edit.vue')
                )*/
		},
		traduci(item) {
			var master = item.trans[0].unit;
			var datapost = [];
			_.forEach(item.trans, tran => {
				if (tran.unit != '') {
					let datapost = {
						target: tran.lang,
						words: {
							unit: tran.unit,
						},
					};
					axios
						.post(`${this.getUrl}translates`, { data: datapost }, { headers: { Authorization: `Bearer ${this.getToken}` } })

						.then(res => {
							tran.unit = res.data.data[0];
						})
						.catch(err => {
							console.log(err);
						});
				}
			});
		},
		save() {
			let url = 'profile/unit';
			axios
				.post(`${this.getUrl}${url}`, this.units, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;
					//   console.log(data.data);
					this.setSettings(data.data);
					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					this.form = {
						vat: '',
						is_active: false,
					};
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		changeDefault(index) {
			_.forEach(this.units, (cur, i) => {
				//console.log(rates[cur.id])

				if (i == index) {
					cur.default = true;
				} else {
					cur.default = false;
				}
			});

			let url = 'profile/unit';
			axios
				.post(`${this.getUrl}${url}`, this.units, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;
					//   console.log(data.data);
					this.setSettings(data.data);
					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					this.form = {
						vat: '',
						is_active: false,
					};
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},

		changeStatus(item) {
			this.dialogconfirm = false;
			this.preload = true;

			let url = 'profile/unit';
			axios
				.post(`${this.getUrl}${url}`, this.units, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;
					//   console.log(data.data);
					this.setSettings(data.data);
					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					this.form = {
						vat: '',
						is_active: false,
					};
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});

			//console.log(item)
		},
		confirmDelete() {
			this.dialogconfirm = false;
			const item = this.daEliminare;
			this.daEliminare = null;
			if (!item) return;
			this.units = this.units.filter(r => r !== item);

			let url = 'profile/unit';
			axios
				.post(`${this.getUrl}${url}`, this.units, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					this.setSettings(data.data);
					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		addValue() {
			this.dialogconfirm = false;
			this.preload = true;

			if (this.form.vat != '') {
				this.vats.push({ is_active: this.form.is_active, vat: this.form.vat, default: false });

				let url = 'profile/vat';
				axios
					.post(`${this.getUrl}${url}`, this.vats, { headers: { Authorization: `Bearer ${this.getToken}` } })
					.then(({ data }) => {
						//   this.dialog = false;
						//   this.success = true;
						//   console.log(data.data);
						this.setSettings(data.data);
						this.preload = false;
						this.snackbar.color = 'success';
						this.snackbar.text = 'Operazione effettuata con  successo';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.form = {
							vat: '',
							is_active: false,
						};
					})
					.catch(err => {
						if (err.response) {
							let errors = err.response.data.error;
							if (errors) {
								if (_.isArray(errors)) {
									errors.forEach(value => {
										//console.log(value.msg);
										this.messages[value.param] = value.msg;
									});
								} else {
									err.message = errors;
								}
							}

							this.snackbar.color = 'error';
							this.snackbar.text = err.message;
							this.snackbar.snackbar = true;
							this.snackbar.mode = 'multi-line';
							this.snackbar.timeout = 5000;
							this.preload = false;
							if (err.response.status === 401) {
								this.setLogout();
								this.$router.push('/login');
							}
						}
					});
			}
		},
		onResize() {
			if (window.innerWidth < 769) this.isMobile = true;
			else this.isMobile = false;
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
			this.clippedOrder = 0;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},
		columnValueList(val) {
			return this.getOrders.map(d => d[val]);
		},

		/*checkInvoice(){
                console.log("ssssssssssssssssssssdentro")
                let el = this.selectedchecbox[0]
                let item = _.find(this.getOrders,i => {
                    return i._id==el
                })
                if(item){
                    if(item.Invoice.Number){
                        console.log("true")
                        return true
                    }else{
                        console.log("false")
                        return false
                    }
                }

            },*/
		toggleClass(num) {
			if (num == 1) {
				this.active = !this.active;
			}
			if (this.active) {
				return 'active';
			} else {
				return 'notActive';
			}
		},
		resetForm() {
			this.form._id = '';
			this.form.name = '';
			this.form.email = '';
			this.form.password = '';
			this.form.action = '';
		},

		async openNew() {
			this.setClearError({});
			//await this.resetMessages();
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		saveSetting(item) {
			var payload;
			switch (item) {
				case 0:
					payload = this.mws;
					this.preload = true;

					break;
				case 1:
					payload = this.ebay;
					this.preload = true;

					break;
			}
			let url = 'profile/update';
			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;
					//   console.log(data.data);

					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});

			//console.log(`${this.getUrl}${url}`);
		},
		extension(item) {
			var prova = this.selected.includes(item);

			if (!prova) {
				this.selected.push(item);
			} else {
				var indice = this.selected.indexOf(item);
				this.selected.splice(indice, 1);
			}
			//console.log(this.selected)
		},
		checkpresenza(item) {
			return this.selected.includes(item);
		},

		getImagePayment(img) {
			let defaultImage = '@/assets/images/Other.svg'; // just set default
			let path = `@/assets/images/${img}.svg`;

			try {
				return require(`@/assets/images/${img}.svg`);
			} catch (e) {
				return require(`@/assets/images/Other.svg`);
			}
		},

		closeSnackbar() {
			this.setSnackbar(false);
		},
		async confirm() {
			let payload = this.form;
			try {
				this.preload = true;
				var response = await this.fetchUsers(payload);
			} catch (err) {
				console.log(err);
			}
			this.preload = false;
		},
		deleteItem(item) {
			this.daEliminare = item;
			this.dialogconfirm = true;
		},
		// nome nella lingua principale del profilo
		nomeUnita(item) {
			return _.get(_.find(item.trans, { lang: this.lang }), 'unit') || _.get(item, 'trans[0].unit') || '';
		},
	},
};
</script>

<style></style>

<style scoped>
/* lista compatta: la riga aperta si colora e sotto compare il riquadro delle traduzioni */
.as-list-row {
	cursor: pointer;
}
.as-list-row--open,
.as-list-row--open:hover {
	background: #f3f6fa !important;
}
.as-expanded,
.as-expanded:hover {
	background: transparent !important;
}
.up-detail {
	border: 1px solid rgba(0, 0, 0, 0.12);
	border-radius: 10px;
	overflow: hidden;
	background: #f3f6fa;
	width: 100%;
}
.up-head {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 4px;
	padding: 8px 12px;
	background: #fff;
	border-bottom: 1px solid #e1e7ef;
	font-size: 13px;
}
.up-head-title {
	font-weight: 600;
	color: #1f2d3d;
}
.up-body {
	padding: 12px;
}
.up-section {
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	color: #5f6b7a;
	margin-bottom: 6px;
}
.up-muted {
	color: #5f6b7a;
}
.up-small {
	font-size: 12px;
}
.up-foot {
	display: flex;
	justify-content: flex-end;
	padding: 8px 12px;
	background: #fff;
	border-top: 1px solid #e1e7ef;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
/* card in lista fuori da v-data-table */
.kv-list > .kv-card + .kv-card {
	margin-top: 8px;
}
</style>
